module.exports = __webpack_public_path__ + "img/selectPayTypeVgmBtnBg.ecdf65ed.png";